<template>
  <div
    v-if="loaded !== false"
    :class="{'active': isMiniMapOpened }"
    class="minimap-component"
  >
    <div class="minimap-container-edges">
      <div class="minimap-container">
        <img
          :src="url"
          class="minimap"
          @load="handleMinimapLoading"
          @error="handleMinimapLoading"
        />
        <marzipano-hotspot
          v-for="hotspot in data.hotspots"
          :key="hotspot.id"
          :active="activeHotspot.id === hotspot.id"
          :data="hotspot"
          :navigate="navigate"
        />
        <svg
          v-if="data.northAngle != null"
          width="47"
          height="47"
          viewBox="0 0 47 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="compass"
        >
          <!--  <rect x=".655" width="35" height="35" rx="17.5" fill="#fff"/>-->
          <circle cx="23.5" cy="23.5" r="17.5" fill="#fff"/>
          <path transform="translate(6, 6)"
                d="M24.125 24.49h-2.8l-6.34-9.58v9.58h-2.8V10.51h2.8l6.34 9.6v-9.6h2.8v13.98z"
                fill="#000"/>
          <path d="m18.5 11 5-11 5 11h-10z" fill="#F40000" :transform="`rotate(${data.northAngle}, 23.5, 23.5)`"/>
        </svg>

      </div>
    </div>
    <img
      :src="closeIcon"
      class="close-icon"
      @click="hideMiniMap()"
    />
    <v-btn fab color="primary themed-color" class="open-icon scale-down-size" @click="showMiniMapAction">
      <img :src="openIcon" class="icon-open"/>
    </v-btn>
  </div>
</template>

<script>
import { imageUrl } from '@/utils/urls';
import MarzipanoHotspot from './MarzipanoHotspot.vue';
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'MarzipanoMinimap',
  components: { MarzipanoHotspot },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    activeHotspot: {
      type: Object,
      default: () => ({}),
    },
    navigate: {
      type: Function,
      required: false,
    },
    openIcon: {
      type: String,
      default: imageUrl('img/marzipano/minimap-open.svg'),
    },
    closeIcon: {
      type: String,
      default: imageUrl('img/marzipano/minimap-close.svg'),
    },
  },
  data() {
    return {
      loaded: this.data.image2dmap ? undefined : false,
    };
  },
  computed: {
    ...mapGetters('service', ['isMiniMapVisible']),
    url() {
      return this.data.image2dmap;
    },
    isMiniMapOpened() {
      return this.isMiniMapVisible
    }
  },
  methods: {
    ...mapActions('sunstudy', ['stopSunstudyMode']),
    ...mapActions('service', ['showMiniMap', 'hideMiniMap']),
    imageUrl,
    handleMinimapLoading(event) {
      this.loaded = event.type === 'load';
    },
    showMiniMapAction() {
      this.showMiniMap();
      this.$vuetify.breakpoint.smAndDown ? this.stopSunstudyMode() : null;
    },
  },
  created() {
    this.$vuetify.breakpoint.smAndDown ? this.hideMiniMap() : null;
  }
};
</script>

<style lang="scss" scoped>
.minimap-component {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1;

  .minimap-container-edges {
    overflow: hidden;
    background-color: rgba(200, 200, 200, 0.8);
    border-radius: 3px;
    padding: 15px;
    transition: margin 0.3s ease, transform 0.3s ease;
  }

  &.active {
    .open-icon {
      visibility: hidden;
    }
  }

  &:not(.active) {
    pointer-events: none;

    .minimap-container-edges, .close-icon {
      visibility: hidden;
    }

    .open-icon {
      pointer-events: auto;

    }

    .scale-down-size {
      transition: transform 0.3s ease;

      @media (max-width: 1500px), (max-height: 920px) {
        transform: scale(0.85);
      }
    }

  }

  .minimap-container {
    position: relative;
  }

  .minimap {
    max-width: 200px;
    max-height: 200px;
    //filter: drop-shadow(0 0 0.75rem gray);
  }

  .close-icon {
    position: absolute;
    right: -10px;
    top: -10px;
    width: 26px;
  }

  .open-icon {
    position: absolute;
    top: 0;
    right: 0;
  }

  .compass {
    position: absolute;
    bottom: -10px;
    right: -10px;
    width: 30px;
    height: 30px;
  }
  .themed-color {
    background-color: var(--primary-color) !important;
  }
}

@media (max-width: 1500px), (max-height: 920px) {
  .minimap-component .minimap-container-edges {
    transform: scale(0.85);
    margin-top: -14px;
    margin-right: -14px;
  }
}
</style>
